module.exports = __webpack_public_path__ + "static/media/out-for-delivery.50908cb1.svg";